import type { CSSProperties } from 'react';
import {
  Activity,
  ArrowLeftRight,
  ArrowRight,
  BarChart3,
  BookOpen,
  Braces,
  Boxes,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  CircleHelp,
  Clapperboard,
  Coins,
  Copy,
  CreditCard,
  ExternalLink,
  FlaskConical,
  FolderKanban,
  Image,
  Info,
  KeyRound,
  LayoutDashboard,
  LayoutGrid,
  List,
  LogOut,
  Menu,
  MessageSquare,
  Monitor,
  Moon,
  OctagonAlert,
  Play,
  Plug,
  Plus,
  Scale,
  Search,
  Settings,
  ShieldCheck,
  Sparkles,
  Square,
  Sun,
  Terminal,
  TriangleAlert,
  User,
  Users,
  Wallet,
  X,
  Zap,
  CircleCheck,
  type LucideIcon,
} from 'lucide-react';

const ICONS = {
  home: LayoutDashboard,
  terminal: FlaskConical,
  code: Terminal,
  grid: LayoutGrid,
  boxes: Boxes,
  book: BookOpen,
  key: KeyRound,
  folder: FolderKanban,
  bars: BarChart3,
  wallet: Wallet,
  swap: ArrowLeftRight,
  gear: Settings,
  logout: LogOut,
  sun: Sun,
  moon: Moon,
  monitor: Monitor,
  plus: Plus,
  copy: Copy,
  check: Check,
  arrow: ArrowRight,
  external: ExternalLink,
  search: Search,
  image: Image,
  video: Clapperboard,
  chat: MessageSquare,
  user: User,
  users: Users,
  card: CreditCard,
  shield: ShieldCheck,
  pulse: Activity,
  coin: Coins,
  list: List,
  scale: Scale,
  plug: Plug,
  bolt: Zap,
  close: X,
  stop: Square,
  play: Play,
  info: Info,
  warn: TriangleAlert,
  error: OctagonAlert,
  success: CircleCheck,
  chevron: ChevronDown,
  left: ChevronLeft,
  right: ChevronRight,
  spark: Sparkles,
  braces: Braces,
  help: CircleHelp,
  menu: Menu,
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof ICONS;

export function Icon({ name, size = 16, style, className }: { name: IconName; size?: number; style?: CSSProperties; className?: string }) {
  const Glyph = ICONS[name];
  const px = Math.max(size, 13);
  return <Glyph size={px} strokeWidth={1.75} aria-hidden className={className} style={{ flex: 'none', ...style }} />;
}
